{
  "expandButtonOpen": "Show less",
  "expandButtonClose": "Show more"
}
